/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { FlexContainer, Navigation, SVGIcon, theme } from "@nordcloud/gnui";
import { BusinessContext } from "~/generated/graphql";
import { ROUTES } from "~/routing/routes";
import { noop } from "~/tools";

type Props = {
  data: Pick<BusinessContext, "color" | "id" | "isPrimary" | "name">[];
  onItemClicked?: () => void;
};

export function BusinessContextList({ data, onItemClicked = noop }: Props) {
  const location = useLocation();
  const isActive = (check: string) => location.pathname === check;

  const getParams = (to: string) => ({
    as: Link,
    to,
    className: `hasBg ${isActive(to) ? "active" : ""}`,
  });

  return (
    <Navigation.Container secondary>
      {data.map((businessContext) => (
        <FlexContainer key={businessContext.id}>
          <Navigation.Item
            css={{ flex: 1 }}
            {...getParams(
              `${ROUTES.businessContexts.index}/${businessContext.id}`
            )}
            onClick={onItemClicked}
          >
            <Indicator
              color={businessContext.color ?? theme.color.support.purple}
            />
            {businessContext.name} <SVGIcon name="arrowRight" />
          </Navigation.Item>
        </FlexContainer>
      ))}
    </Navigation.Container>
  );
}

const Indicator = styled.div<{ color: string }>`
  width: 0.75rem;
  height: 1.5rem;
  background-color: ${(props) => props.color};
  border-radius: 2px;
`;
